import axios from 'axios';

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
/**
* Access options for vod items

1 = Free

2 = Registration

3 = Subscribe
* @format int32
*/
var AccessOptions;
(function (AccessOptions) {
    AccessOptions[AccessOptions["Free"] = 1] = "Free";
    AccessOptions[AccessOptions["Registration"] = 2] = "Registration";
    AccessOptions[AccessOptions["Subscribe"] = 3] = "Subscribe";
})(AccessOptions || (AccessOptions = {}));
/**
* Predefined list of possible content advisory raitings.

0 = NR

1 = PG1

2 = PG2

3 = PG3

4 = PG4

5 = R
* @format int32
*/
var Advisory;
(function (Advisory) {
    Advisory[Advisory["NR"] = 0] = "NR";
    Advisory[Advisory["PG1"] = 1] = "PG1";
    Advisory[Advisory["PG2"] = 2] = "PG2";
    Advisory[Advisory["PG3"] = 3] = "PG3";
    Advisory[Advisory["PG4"] = 4] = "PG4";
    Advisory[Advisory["R"] = 5] = "R";
})(Advisory || (Advisory = {}));
/**
* Content level item

1 = Series

2 = Season

3 = Episode

4 = Movie
* @format int32
*/
var AppleContentLevel;
(function (AppleContentLevel) {
    AppleContentLevel[AppleContentLevel["Series"] = 1] = "Series";
    AppleContentLevel[AppleContentLevel["Season"] = 2] = "Season";
    AppleContentLevel[AppleContentLevel["Episode"] = 3] = "Episode";
    AppleContentLevel[AppleContentLevel["Movie"] = 4] = "Movie";
})(AppleContentLevel || (AppleContentLevel = {}));
/**
* Definition of types of genres depending on the type of client services (such as Live TV, VOD etc.)

0 = UnknownGenreType

1 = TvGenreType

2 = VodGenreType

3 = ProgramGenreType

4 = ArcplusGenreType

5 = VodInternalGenreType
* @format int32
*/
var ContentGenreType;
(function (ContentGenreType) {
    ContentGenreType[ContentGenreType["UnknownGenreType"] = 0] = "UnknownGenreType";
    ContentGenreType[ContentGenreType["TvGenreType"] = 1] = "TvGenreType";
    ContentGenreType[ContentGenreType["VodGenreType"] = 2] = "VodGenreType";
    ContentGenreType[ContentGenreType["ProgramGenreType"] = 3] = "ProgramGenreType";
    ContentGenreType[ContentGenreType["ArcplusGenreType"] = 4] = "ArcplusGenreType";
    ContentGenreType[ContentGenreType["VodInternalGenreType"] = 5] = "VodInternalGenreType";
})(ContentGenreType || (ContentGenreType = {}));
/**
*

0 = AudioBooks

1 = DVR

2 = Games

3 = Karaoke

4 = LiveTV

5 = Music

6 = Podcast

7 = Radio

8 = ArcPlus

9 = VOD

10 = SVOD

11 = CraveTV
* @format int32
*/
var ContentType;
(function (ContentType) {
    ContentType[ContentType["AudioBooks"] = 0] = "AudioBooks";
    ContentType[ContentType["DVR"] = 1] = "DVR";
    ContentType[ContentType["Games"] = 2] = "Games";
    ContentType[ContentType["Karaoke"] = 3] = "Karaoke";
    ContentType[ContentType["LiveTV"] = 4] = "LiveTV";
    ContentType[ContentType["Music"] = 5] = "Music";
    ContentType[ContentType["Podcast"] = 6] = "Podcast";
    ContentType[ContentType["Radio"] = 7] = "Radio";
    ContentType[ContentType["ArcPlus"] = 8] = "ArcPlus";
    ContentType[ContentType["VOD"] = 9] = "VOD";
    ContentType[ContentType["SVOD"] = 10] = "SVOD";
    ContentType[ContentType["CraveTV"] = 11] = "CraveTV";
})(ContentType || (ContentType = {}));
/**
* genre types premium/basic

1 = Basic

2 = Premium
* @format int32
*/
var GenreType;
(function (GenreType) {
    GenreType[GenreType["Basic"] = 1] = "Basic";
    GenreType[GenreType["Premium"] = 2] = "Premium";
})(GenreType || (GenreType = {}));
/**
* VOD/guide item type

0 = Schedule

1 = Program

2 = Container

3 = Episode

4 = Movie

5 = Season
* @format int32
*/
var ItemType;
(function (ItemType) {
    ItemType[ItemType["Schedule"] = 0] = "Schedule";
    ItemType[ItemType["Program"] = 1] = "Program";
    ItemType[ItemType["Container"] = 2] = "Container";
    ItemType[ItemType["Episode"] = 3] = "Episode";
    ItemType[ItemType["Movie"] = 4] = "Movie";
    ItemType[ItemType["Season"] = 5] = "Season";
})(ItemType || (ItemType = {}));
/**
*

1 = VodMain

4 = ChannelLogoTransparent36

8 = ChannelLogoWhiteTransparent

10 = ChannelLogoOriginal

28 = TvProgram

29 = TvProgram16x9

41 = VodGenre

42 = VodGenreMonochrome

43 = VodScreenshot

44 = VodWallpaper

45 = VodCredit

46 = VodPerson

47 = Season

48 = Episode

49 = TopShelf

50 = Label

51 = VodTopGenrePoster

52 = VodTopGenreWallpaper

101 = StoreProduct
* @format int32
*/
var MediaImageTypes;
(function (MediaImageTypes) {
    MediaImageTypes[MediaImageTypes["VodMain"] = 1] = "VodMain";
    MediaImageTypes[MediaImageTypes["ChannelLogoTransparent36"] = 4] = "ChannelLogoTransparent36";
    MediaImageTypes[MediaImageTypes["ChannelLogoWhiteTransparent"] = 8] = "ChannelLogoWhiteTransparent";
    MediaImageTypes[MediaImageTypes["ChannelLogoOriginal"] = 10] = "ChannelLogoOriginal";
    MediaImageTypes[MediaImageTypes["TvProgram"] = 28] = "TvProgram";
    MediaImageTypes[MediaImageTypes["TvProgram16X9"] = 29] = "TvProgram16X9";
    MediaImageTypes[MediaImageTypes["VodGenre"] = 41] = "VodGenre";
    MediaImageTypes[MediaImageTypes["VodGenreMonochrome"] = 42] = "VodGenreMonochrome";
    MediaImageTypes[MediaImageTypes["VodScreenshot"] = 43] = "VodScreenshot";
    MediaImageTypes[MediaImageTypes["VodWallpaper"] = 44] = "VodWallpaper";
    MediaImageTypes[MediaImageTypes["VodCredit"] = 45] = "VodCredit";
    MediaImageTypes[MediaImageTypes["VodPerson"] = 46] = "VodPerson";
    MediaImageTypes[MediaImageTypes["Season"] = 47] = "Season";
    MediaImageTypes[MediaImageTypes["Episode"] = 48] = "Episode";
    MediaImageTypes[MediaImageTypes["TopShelf"] = 49] = "TopShelf";
    MediaImageTypes[MediaImageTypes["Label"] = 50] = "Label";
    MediaImageTypes[MediaImageTypes["VodTopGenrePoster"] = 51] = "VodTopGenrePoster";
    MediaImageTypes[MediaImageTypes["VodTopGenreWallpaper"] = 52] = "VodTopGenreWallpaper";
    MediaImageTypes[MediaImageTypes["StoreProduct"] = 101] = "StoreProduct";
})(MediaImageTypes || (MediaImageTypes = {}));
/**
*

129 = MoviesOnTv

130 = SportsOnTv

131 = KidsOnTv

132 = NewsOnTv

133 = MoviesOnTvLookback

134 = SportsOnTvLookback

135 = KidsOnTvLookback

136 = NewsOnTvLookback

138 = OlympicsOnTv

139 = OlympicsOnTvLookback

146 = SeriesOnTv

147 = SeriesOnTvLookback

151 = SeriesOnTvExcludingKidsSportsNews

152 = SeriesOnTvExcludingKidsSportsNewsLookback
* @format int32
*/
var OnTvType;
(function (OnTvType) {
    OnTvType[OnTvType["MoviesOnTv"] = 129] = "MoviesOnTv";
    OnTvType[OnTvType["SportsOnTv"] = 130] = "SportsOnTv";
    OnTvType[OnTvType["KidsOnTv"] = 131] = "KidsOnTv";
    OnTvType[OnTvType["NewsOnTv"] = 132] = "NewsOnTv";
    OnTvType[OnTvType["MoviesOnTvLookback"] = 133] = "MoviesOnTvLookback";
    OnTvType[OnTvType["SportsOnTvLookback"] = 134] = "SportsOnTvLookback";
    OnTvType[OnTvType["KidsOnTvLookback"] = 135] = "KidsOnTvLookback";
    OnTvType[OnTvType["NewsOnTvLookback"] = 136] = "NewsOnTvLookback";
    OnTvType[OnTvType["OlympicsOnTv"] = 138] = "OlympicsOnTv";
    OnTvType[OnTvType["OlympicsOnTvLookback"] = 139] = "OlympicsOnTvLookback";
    OnTvType[OnTvType["SeriesOnTv"] = 146] = "SeriesOnTv";
    OnTvType[OnTvType["SeriesOnTvLookback"] = 147] = "SeriesOnTvLookback";
    OnTvType[OnTvType["SeriesOnTvExcludingKidsSportsNews"] = 151] = "SeriesOnTvExcludingKidsSportsNews";
    OnTvType[OnTvType["SeriesOnTvExcludingKidsSportsNewsLookback"] = 152] = "SeriesOnTvExcludingKidsSportsNewsLookback";
})(OnTvType || (OnTvType = {}));
/**
* Predefined list of possible program types

0 = Unknown

1 = Compilation

2 = Episode

3 = FeatureFilm

4 = Miniseries

5 = PaidProgramming

6 = Preview

7 = SeasonOfASeries

8 = Series

9 = ShortFilm

10 = Special

11 = SportsEvent

12 = SportsNonEvent

13 = TvMovie

14 = TeamEvent

15 = TheatreEvent

16 = Trailer

17 = Highlights

18 = MusicVideo

19 = TBA

20 = OffAir
* @format int32
*/
var ProgramType;
(function (ProgramType) {
    ProgramType[ProgramType["Unknown"] = 0] = "Unknown";
    ProgramType[ProgramType["Compilation"] = 1] = "Compilation";
    ProgramType[ProgramType["Episode"] = 2] = "Episode";
    ProgramType[ProgramType["FeatureFilm"] = 3] = "FeatureFilm";
    ProgramType[ProgramType["Miniseries"] = 4] = "Miniseries";
    ProgramType[ProgramType["PaidProgramming"] = 5] = "PaidProgramming";
    ProgramType[ProgramType["Preview"] = 6] = "Preview";
    ProgramType[ProgramType["SeasonOfASeries"] = 7] = "SeasonOfASeries";
    ProgramType[ProgramType["Series"] = 8] = "Series";
    ProgramType[ProgramType["ShortFilm"] = 9] = "ShortFilm";
    ProgramType[ProgramType["Special"] = 10] = "Special";
    ProgramType[ProgramType["SportsEvent"] = 11] = "SportsEvent";
    ProgramType[ProgramType["SportsNonEvent"] = 12] = "SportsNonEvent";
    ProgramType[ProgramType["TvMovie"] = 13] = "TvMovie";
    ProgramType[ProgramType["TeamEvent"] = 14] = "TeamEvent";
    ProgramType[ProgramType["TheatreEvent"] = 15] = "TheatreEvent";
    ProgramType[ProgramType["Trailer"] = 16] = "Trailer";
    ProgramType[ProgramType["Highlights"] = 17] = "Highlights";
    ProgramType[ProgramType["MusicVideo"] = 18] = "MusicVideo";
    ProgramType[ProgramType["TBA"] = 19] = "TBA";
    ProgramType[ProgramType["OffAir"] = 20] = "OffAir";
})(ProgramType || (ProgramType = {}));
/**
* Deep link provider

1 = Apple

2 = Android

3 = Roku
* @format int32
*/
var Provider;
(function (Provider) {
    Provider[Provider["Apple"] = 1] = "Apple";
    Provider[Provider["Android"] = 2] = "Android";
    Provider[Provider["Roku"] = 3] = "Roku";
})(Provider || (Provider = {}));
/**
* Show type of item

0 = None

1 = Movie

2 = Series

4 = Special
* @format int32
*/
var ShowTypes;
(function (ShowTypes) {
    ShowTypes[ShowTypes["None"] = 0] = "None";
    ShowTypes[ShowTypes["Movie"] = 1] = "Movie";
    ShowTypes[ShowTypes["Series"] = 2] = "Series";
    ShowTypes[ShowTypes["Special"] = 4] = "Special";
})(ShowTypes || (ShowTypes = {}));
/**
* Predefined list of possible subscription service statuses

1 = Available

2 = Enabled

3 = NA

4 = PreviewAvailable
* @format int32
*/
var Status;
(function (Status) {
    Status[Status["Available"] = 1] = "Available";
    Status[Status["Enabled"] = 2] = "Enabled";
    Status[Status["NA"] = 3] = "NA";
    Status[Status["PreviewAvailable"] = 4] = "PreviewAvailable";
})(Status || (Status = {}));
/**
* Restrictions for a media stream.

0 = None

1 = FastForward

2 = Rewind

4 = Pause
* @format int32
*/
var TrickModeRestriction;
(function (TrickModeRestriction) {
    TrickModeRestriction[TrickModeRestriction["None"] = 0] = "None";
    TrickModeRestriction[TrickModeRestriction["FastForward"] = 1] = "FastForward";
    TrickModeRestriction[TrickModeRestriction["Rewind"] = 2] = "Rewind";
    TrickModeRestriction[TrickModeRestriction["Pause"] = 4] = "Pause";
})(TrickModeRestriction || (TrickModeRestriction = {}));
/**
* Tv Qualifier

6 = Cc

12 = Dvs

35 = SubTitled
* @format int32
*/
var TvQualifier;
(function (TvQualifier) {
    TvQualifier[TvQualifier["Cc"] = 6] = "Cc";
    TvQualifier[TvQualifier["Dvs"] = 12] = "Dvs";
    TvQualifier[TvQualifier["SubTitled"] = 35] = "SubTitled";
})(TvQualifier || (TvQualifier = {}));
/**
* Scope of search of Video on demand types

0 = All

1 = VOD

2 = SVOD

3 = PPV

4 = CraveTV
* @format int32
*/
var VodType;
(function (VodType) {
    VodType[VodType["All"] = 0] = "All";
    VodType[VodType["VOD"] = 1] = "VOD";
    VodType[VodType["SVOD"] = 2] = "SVOD";
    VodType[VodType["PPV"] = 3] = "PPV";
    VodType[VodType["CraveTV"] = 4] = "CraveTV";
})(VodType || (VodType = {}));
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title Futhark API
 * @version 3.0
 */
class Api extends HttpClient {
    api = {
        /**
         * No description
         *
         * @tags GuideControllerV3
         * @name V3GuideClientList
         * @summary Get guide for client mode
         * @request GET:/api/v3/guide/client
         * @response `200` `ProgramGuide` OK
         */
        v3GuideClientList: (query, params = {}) => this.request({
            path: `/api/v3/guide/client`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GuideControllerV3
         * @name V3GuideAppList
         * @summary Get guide for guide mode
         * @request GET:/api/v3/guide/app
         * @response `200` `ProgramGuide` OK
         */
        v3GuideAppList: (query, params = {}) => this.request({
            path: `/api/v3/guide/app`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GuideControllerV3
         * @name V3GuideClientOntvDetail
         * @summary Get content for 'On TV' rows
         * @request GET:/api/v3/guide/client/ontv/{type}
         * @response `200` `ProgramGuide` OK
         */
        v3GuideClientOntvDetail: ({ type, ...query }, params = {}) => this.request({
            path: `/api/v3/guide/client/ontv/${type}`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GuideControllerV3
         * @name V3GuideAppOntvDetail
         * @summary Get content for 'On TV' rows
         * @request GET:/api/v3/guide/app/ontv/{type}
         * @response `200` `ProgramGuide` OK
         */
        v3GuideAppOntvDetail: ({ type, ...query }, params = {}) => this.request({
            path: `/api/v3/guide/app/ontv/${type}`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GuideControllerV3
         * @name V3GuideWatchedList
         * @summary Get watched content
         * @request GET:/api/v3/guide/watched
         * @response `200` `ProgramGuide` OK
         */
        v3GuideWatchedList: (query, params = {}) => this.request({
            path: `/api/v3/guide/watched`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
}

export { AccessOptions, Advisory, Api, AppleContentLevel, ContentGenreType, ContentType, GenreType, HttpClient, ItemType, MediaImageTypes, OnTvType, ProgramType, Provider, ShowTypes, Status, TrickModeRestriction, TvQualifier, VodType };
